module.exports = __webpack_public_path__ + "static/media/WBN_STANDARD.34e3f232.svg";